module.exports = __webpack_public_path__ + "img/ombre.c102021b.png";